import React, { Component } from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import Modal from '../Modal/Modal';

import MediaInput from '../MediaInput/MediaInput';
import CustomMultiSelect from '../CustomMultiSelect/CustomMultiSelect';
import './UploadMediaModal.scss';
import { getFieldInitialState } from '../../../utils/helpers';
import Button from '../../_atomic/Button/Button';
import { TEXT_FIELD_STATUS, LOADING, SUCCESS } from '../../../utils/constants';

const appSelectFieldName = 'app-select';
const campaignSelectFieldName = 'campaign-select';
const authorSelectFieldName = 'author-select';

const authorsValues = [
  {
    value: 'ADMIN',
    label: 'Admin',
  },
  {
    value: 'USER',
    label: 'User',
  }, {
    value: 'COMPETITOR',
    label: 'Competitor',
  },
];

class UploadMediaModal extends Component {
  static propTypes = {
    visible: PropTypes.bool.isRequired,
    apps: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    currentUpdateApp: PropTypes.string,
    currentUpdateCampaign: PropTypes.string,
    uploadMedia: PropTypes.func.isRequired,
    requestClose: PropTypes.func.isRequired,
    getAppWithMedia: PropTypes.func.isRequired,
    uploadMediaStatus: PropTypes.string.isRequired,
    currentAppCampaigns: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    getAppCampaigns: PropTypes.func.isRequired,
    isAdmin: PropTypes.bool,
  };
  static defaultProps = {
    currentUpdateApp: '',
    currentUpdateCampaign: '',
    isAdmin: false,
  };
  state = {
    selectedMedias: [],
    selectMediasStatus: TEXT_FIELD_STATUS.INIT,
    fields: {
      [appSelectFieldName]: getFieldInitialState(),
      [campaignSelectFieldName]: getFieldInitialState(false, false, []),
      [authorSelectFieldName]: getFieldInitialState(false, false, 'ADMIN'),
    },
    successModal: false,
  };
  componentWillMount() {
    const fields = { ...this.state.fields };
    const { currentUpdateApp, currentUpdateCampaign, getAppCampaigns } = this.props;

    if (currentUpdateApp) {
      getAppCampaigns({ appId: currentUpdateApp });
      fields[appSelectFieldName].value = currentUpdateApp;
    }
    if (currentUpdateCampaign) {
      fields[campaignSelectFieldName].value.push(currentUpdateCampaign);
    }

    this.setState(() => ({
      fields,
    }));
  }
  componentDidUpdate(prevProps) {
    const fields = { ...this.state.fields };
    const {
      apps,
      currentUpdateApp,
      uploadMediaStatus,
      getAppWithMedia,
    } = this.props;
    if (prevProps.apps.length === 0 && apps.length) {
      if (!currentUpdateApp) {
        fields[appSelectFieldName].value = apps[0].id;
        fields[appSelectFieldName].status = TEXT_FIELD_STATUS.VALID;
      }
      this.setState(() => ({
        fields,
      }));
    }

    if (
      uploadMediaStatus !== prevProps.uploadMediaStatus &&
      (uploadMediaStatus === LOADING || uploadMediaStatus === SUCCESS) &&
      !this.mediaUploadInterval
    ) {
      this.mediaUploadInterval = setInterval(() => {
        const parameters = {};
        if (this.state.fields[appSelectFieldName].value.value) {
          parameters.appId = this.state.fields[appSelectFieldName].value.value;
        } else {
          parameters.appId = this.state.fields[appSelectFieldName].value;
        }

        getAppWithMedia(parameters);
      }, 3000);
    }
  }

  componentWillUnmount() {
    clearInterval(this.mediaUploadInterval);
    this.mediaUploadInterval = undefined;
  }
  requestClose = () => {
    let fields = { ...this.state.fields };
    let selectedMedias = [...this.state.selectedMedias];

    const { successModal } = this.state;
    const { currentUpdateApp } = this.props;
    if (!currentUpdateApp && successModal) {
      fields = {
        [appSelectFieldName]: getFieldInitialState(),
        [campaignSelectFieldName]: getFieldInitialState(false, false, []),
        [authorSelectFieldName]: getFieldInitialState(false, false, 'ADMIN'),
      };
      selectedMedias = [];
    }
    this.setState(
      () => ({
        selectedMedias,
        selectMediasStatus: TEXT_FIELD_STATUS.INITIAL,
        successModal: false,
        fields,
      }),
      () => {
        this.props.requestClose();
      },
    );
  };

  fieldChangeHandler = ({ name, value }) => {
    const fields = {
      ...this.state.fields,
    };
    const { getAppCampaigns } = this.props;
    fields[name].value = value;
    if (name === campaignSelectFieldName) {
      if (fields[name].value.length) {
        fields[campaignSelectFieldName].status = TEXT_FIELD_STATUS.VALID;
      } else {
        fields[name].status = TEXT_FIELD_STATUS.INVALID;
      }
    }

    if (name === appSelectFieldName) {
      if (fields[name].value) {
        fields[appSelectFieldName].status = TEXT_FIELD_STATUS.VALID;
      } else {
        fields[name].status = TEXT_FIELD_STATUS.INVALID;
      }
      fields[campaignSelectFieldName].value = [];
    }

    this.setState(
      () => ({ fields }),
      () => {
        if (name === appSelectFieldName) {
          const appId = value.value || value;

          getAppCampaigns({ appId });
        }
      },
    );
  };

  mediaChangeHandler = (value) => {
    // don't destructing state, coz value is already immutable concatenated with
    // state
    const selectedMedias = [...value];
    let { selectMediasStatus } = this.state;
    if (selectMediasStatus === TEXT_FIELD_STATUS.INVALID && selectedMedias.length) {
      selectMediasStatus = TEXT_FIELD_STATUS.VALID;
    }
    this.setState(() => ({ selectedMedias, selectMediasStatus }));
  };

  submitHandler = (e) => {
    e.preventDefault();
    let { selectMediasStatus } = this.state;
    const { selectedMedias, fields } = this.state;
    const { isAdmin } = this.props;
    if (selectedMedias.length) {
      selectMediasStatus = TEXT_FIELD_STATUS.VALID;
    } else {
      selectMediasStatus = TEXT_FIELD_STATUS.INVALID;
    }
    if (fields[campaignSelectFieldName].value.length) {
      fields[campaignSelectFieldName].status = TEXT_FIELD_STATUS.VALID;
    } else {
      fields[campaignSelectFieldName].status = TEXT_FIELD_STATUS.INVALID;
    }
    if (fields[appSelectFieldName].value) {
      fields[appSelectFieldName].status = TEXT_FIELD_STATUS.VALID;
    } else {
      fields[appSelectFieldName].status = TEXT_FIELD_STATUS.INVALID;
    }
    this.setState(
      () => ({
        selectMediasStatus,
      }),
      () => {
        if (
          selectMediasStatus === TEXT_FIELD_STATUS.VALID &&
          fields[campaignSelectFieldName].status === TEXT_FIELD_STATUS.VALID
        ) {
          const { value } = fields[campaignSelectFieldName];
          const data = {
            app:
              fields[appSelectFieldName].value.value ||
              fields[appSelectFieldName].value,
            campaigns:
              typeof value[0] === 'string'
                ? value
                : value.map(valueItem => valueItem.value),
            author: isAdmin ? (fields[authorSelectFieldName].value.value ||
              fields[authorSelectFieldName].value) : 'USER',
            selectedMedias,
          };
          this.setState(() => ({
            successModal: true,
          }));
          this.props.uploadMedia(data);
        }
      },
    );
  };

  render() {
    const {
      visible,
      apps,
      currentUpdateApp,
      currentUpdateCampaign,
      currentAppCampaigns,
      isAdmin,
    } = this.props;
    const {
      selectedMedias,
      fields,
      selectMediasStatus,
      successModal,
    } = this.state;
    const mediasLength = selectedMedias.length;
    const appSelectField = fields[appSelectFieldName];
    const campaignSelectField = fields[campaignSelectFieldName];
    const authorSelectField = fields[authorSelectFieldName];
    const buttonLabel = mediasLength ? 'Upload More' : 'Upload Files';

    const campaignSelectClasses = classNames({
      'campaign-select': true,
      'for-current-campaign': currentUpdateCampaign,
    });
    const errorTextClasses = classNames({
      'error-text': true,
      'show-error-text': selectMediasStatus === TEXT_FIELD_STATUS.INVALID,
    });
    const uploadFilesWrapperClasses = classNames({
      'upload-files-modal-wrapper': true,
      'show-success': successModal,
    });

    return (
      <Modal
        visible={visible}
        requestClose={this.requestClose}
        className="upload-media-modal"
      >
        <div className={uploadFilesWrapperClasses}>
          <div className="sections-wrapper">
            <div className="select-wrapper">
              <div className="main-label-no-transform">
                <span>Upload Files</span>
              </div>
              <div className="upload-files-row">
                <div className="files-count">
                  {' '}
                  <span>
                    {mediasLength} {mediasLength === 1 ? 'file' : 'files'}
                  </span>
                </div>
                <MediaInput
                  changeHandler={this.mediaChangeHandler}
                  secondary={mediasLength}
                  buttonLabel={buttonLabel}
                  accept="image/png, image/jpeg, video/mp4"
                  value={selectedMedias}
                />
                <div className={errorTextClasses}>
                  <span>Please select files</span>
                </div>
              </div>
              <form onSubmit={this.submitHandler} className="upload-info-form">
                {isAdmin &&
                <CustomMultiSelect
                  placeholder="Author"
                  label="Author"
                  value={authorSelectField.value}
                  values={authorsValues}
                  changeHandler={this.fieldChangeHandler}
                  className="author-select"
                  name={authorSelectFieldName}
                  closeOnSelect
                  focusHandler={() => {}}
                  multi={false}
                />}
                <CustomMultiSelect
                  placeholder="Application"
                  label="Application"
                  disabled={currentUpdateApp}
                  value={appSelectField.value}
                  values={apps}
                  closeOnSelect
                  changeHandler={this.fieldChangeHandler}
                  status={appSelectField.status}
                  className="application-select"
                  name={appSelectFieldName}
                  isRequired
                  focusHandler={() => {}}
                  multi={false}
                />
                <CustomMultiSelect
                  placeholder="Campaigns"
                  label="Campaigns"
                  name={campaignSelectFieldName}
                  values={currentAppCampaigns}
                  closeOnSelect
                  value={campaignSelectField.value}
                  changeHandler={this.fieldChangeHandler}
                  isRequired
                  disabled={!appSelectField.value}
                  status={campaignSelectField.status}
                  multi
                  focusHandler={() => {}}
                  className={campaignSelectClasses}
                />

                <div className="button-wrapper">
                  <Button type="submit" label="Save" />
                </div>
              </form>
            </div>
            <div className="success-wrapper">
              <div className="main-label-no-transform">
                <span>Files are loading</span>
              </div>
              <div className="plain-text">
                <span>your files will be uploaded soon</span>
              </div>
              <div className="button-wrapper">
                <Button label="OK" clickHandler={this.requestClose} />
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}

export default UploadMediaModal;



// WEBPACK FOOTER //
// ./src/components/_molecules/UploadMediaModal/UploadMediaModal.js